export default {
  methods: {
    /**
     * Get an array of friends for a specific user.
     * @param {string} username
     * @returns {Promise<{id: number, profile_pic: string, username: string}[]>}
     * an array of user objects containing usernames, profile picture urls, etc.
     */
    getFriends: async function (username) {
      let response = await this.$axios.get("/contacts", {
        params: { user: username },
      });
      return response.data;
    },

    /**
     * Returns a user's incoming friend requests only if properly authenticated
     * @returns {Promise<{id: number, profile_pic: string, username: string}[]>}
     */
    getIncomingRequests: async function () {
      let response = await this.$axios.get("/incoming-requests");
      return response.data;
    },

    getOutgoingRequests: async function () {
      let response = await this.$axios.get("/outgoing-requests");
      return response.data;
    },

    /**
     * Sends friend request only if properly authenticated
     * @param {string} username
     * @returns {Promise<boolean>} True if the POST request was successfully made
     */
    addFriend: async function (username) {
      try {
        await this.$axios.post("/connect", {
          recipient: username,
        });
        return true;
      } catch {
        return false;
      }
    },

    /**
     * Sends friend request only if properly authenticated
     * @param {int} friendUserId
     * @returns {Promise<Object>} Returns the response data
     */
    addFriendById: async function (friendUserId) {
      const response = await this.$axios.put(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
      this.$store.commit("decrementNotifications");
      return response.data;
    },

    removeFriendById: async function (friendUserId) {
      const response = await this.$axios.delete(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
      return response.data;
    },

    /**
     * For use with api v1
     */
    getFriendshipStatus: async function (friendUserId) {
      try {
        const response = await this.$axios.get(`/v1/users/${this.$store.state.userId}/friendships/${friendUserId}`);
        return response.data.requestStatus;
      } catch (error) {
        if (error.response.status === 404) {
          return null;
        } else {
          console.log(error.response);
          console.error(error);
        }
      }
    },

    unfriend: async function (username) {
      try {
        await this.$axios.delete("/connection", {
          params: { user: username },
        });
        return true;
      } catch {
        return false;
      }
    },
  },
};
